<template>
  <v-btn small :loading="loading" :disabled="loading || !artworks.length" @click="download">
    <v-icon small class="mr-2">mdi-file-word</v-icon>Text review DOCX
    <span v-if="loading && total" class="ml-2">{{ completed }}/{{ total }}</span>
  </v-btn>
</template>

<script>
import { loadTextReviewData } from '@/utils/textReviewExport'
import { buildTextReviewDocx } from '@/utils/textReviewDocx'

export default {
  props: { artworks: { type: Array, default: () => [] } },
  data: () => ({ loading: false, completed: 0, total: 0 }),
  methods: {
    async download() {
      this.loading = true
      this.completed = 0
      this.total = this.artworks.reduce((count, artwork) => count + (artwork.artwork_texts || []).length, 0)
      try {
        const review = await loadTextReviewData(
          this.artworks,
          this.$globals.apiserver,
          completed => { this.completed = completed }
        )
        const blob = await buildTextReviewDocx(review)
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `artwork-text-review-${new Date().toISOString().slice(0, 10)}.docx`
        document.body.appendChild(link)
        link.click()
        link.remove()
        URL.revokeObjectURL(url)
      } catch (error) {
        this.$emit('error', 'Text review DOCX could not be generated.')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/lists/TextReviewDocx.vue